/* Homepage motion (2026 redesign): scroll reveals, a one-time count-up, and the best-seller swipe row buttons.
   Loaded by every homepage section; runs once. Nothing loops, and nothing moves for reduced-motion visitors. */
(function () {
  'use strict';
  if (window.__bhmHome) return;
  window.__bhmHome = true;

  var docEl = document.documentElement;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var design = !!(window.Shopify && window.Shopify.designMode);
  var motion = docEl.classList.contains('bhm-motion') && !reduce.matches && !design && 'IntersectionObserver' in window;
  // Content is hidden for the reveal only from here on, so a script that never loads never hides anything
  if (motion) docEl.classList.add('bhm-ready'); else docEl.classList.remove('bhm-motion');

  function fmt(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function countUp(el) {
    if (el.dataset.bhmCounted) return;
    el.dataset.bhmCounted = '1';
    var target = Number(el.getAttribute('data-bhm-count'));
    if (!motion || !(target > 0)) return;
    var start = null, dur = 1100;
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt(target * eased);
      if (t < 1) window.requestAnimationFrame(step); else el.textContent = fmt(target);
    }
    el.textContent = '0';
    window.requestAnimationFrame(step);
  }

  var io = null;
  // In a row that scrolls sideways, all its cards reveal together, so a card swiped or tabbed into view is never blank
  function reveal(el) {
    var p = el.parentElement;
    var group = p && p.hasAttribute('data-bhm-track') && p.scrollWidth > p.clientWidth + 4 ? p.children : [el];
    Array.prototype.forEach.call(group, function (x) {
      if (!x.hasAttribute('data-reveal') || x.classList.contains('is-in')) return;
      x.classList.add('is-in');
      if (io) io.unobserve(x);
      Array.prototype.forEach.call(x.querySelectorAll('[data-bhm-count]'), countUp);
    });
  }
  if (motion) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) reveal(e.target); });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
  }
  function initReveals(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-reveal]:not(.is-in)'), function (el) {
      if (io) io.observe(el); else reveal(el);
    });
  }

  /* Swipe row: previous and next buttons, shown only when the row actually scrolls */
  function initTracks(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-bhm-track]'), function (track) {
      if (track.dataset.bhmTrack === 'ready') return;
      track.dataset.bhmTrack = 'ready';
      var section = track.closest('section') || scope;
      var wrap = section.querySelector('[data-bhm-scroll-btns]');
      var prev = section.querySelector('[data-bhm-prev]');
      var next = section.querySelector('[data-bhm-next]');
      if (!wrap || !prev || !next) return;
      function stepSize() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var scrollable = track.scrollWidth > track.clientWidth + 4;
        wrap.hidden = !scrollable;
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
      function go(dir) {
        track.scrollBy({ left: dir * stepSize(), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { if (prev.getAttribute('aria-disabled') !== 'true') go(-1); });
      next.addEventListener('click', function () { if (next.getAttribute('aria-disabled') !== 'true') go(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      // Tabbing through the row: bring the focused card fully into view (scroll-snap would otherwise leave it half hidden)
      track.addEventListener('focusin', function (e) {
        var card = e.target.closest('.bhm-card');
        if (!card || (e.target.matches && !e.target.matches(':focus-visible'))) return;
        var t = track.getBoundingClientRect(), c = card.getBoundingClientRect();
        if (c.left < t.left || c.right > t.right) card.scrollIntoView({ inline: 'start', block: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' });
      });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(scope) { initReveals(scope); initTracks(scope); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
